;(function () {
  angular
    .module('contrast.cve')
    .controller('csCveCountCtrl', [
      'LibraryFactory',
      'ErrorService',
      '$element',
      'GoogleAnalyticsService',
      'csAnalyticsEventsService',
      csCveCountCtrl
    ])

  function csCveCountCtrl(
    LibraryFactory,
    ErrorService,
    $element,
    GoogleAnalyticsService,
    csAnalyticsEventsService
  ) {
    var vm = this

    var tooltipTemplateUrl = 'views/cs-cve-count-tooltip.html'

    vm.isVulnsForLibLoaded = false
    vm.activate = activate
    vm.determineTooltip = determineTooltip
    vm.getTotalVulnerabilities = getTotalVulnerabilities
    vm.getHighVulnerabilities = getHighVulnerabilities

    function activate(params) {
      if (!angular.isObject(params)) {
        throw new Error('params must be an object')
      }
      vm.library = params.library
      _getVulnsForLib()
    }

    function determineTooltip() {
      return vm.library.total_vulnerabilities > 0
        ? tooltipTemplateUrl
        : undefined
    }

    function getTotalVulnerabilities() {
      return vm.library.total_vulnerabilities
    }

    function _getVulnsForLib() {
      if (vm.library.total_vulnerabilities > 0) {
        $element.on('mouseover', function () {
          var event = csAnalyticsEventsService.getEvent(
            'libraries.tooltip.cves'
          )
          GoogleAnalyticsService.sendEvent(event)

          if (!vm.isVulnsForLibLoaded) {
            LibraryFactory.getByLang(
              vm.library.app_language,
              vm.library.hash,
              'vulns',
              null,
              null
            ).then(_onSuccess, ErrorService.processError)
          }
        })
      }
    }

    function _onSuccess(response) {
      vm.library.vulns = response.data.library.vulns
      vm.isVulnsForLibLoaded = true
    }

    function getHighVulnerabilities() {
      return vm.library.high_vulnerabilities
    }
  }
}).call(this)
